import { render, staticRenderFns } from "./DialogPaypalSetting.pug?vue&type=template&id=e3031666&scoped=true&lang=pug&"
import script from "./DialogPaypalSetting.vue?vue&type=script&lang=js&"
export * from "./DialogPaypalSetting.vue?vue&type=script&lang=js&"
import style0 from "./DialogPaypalSetting.scss?vue&type=style&index=0&id=e3031666&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3031666",
  null
  
)

export default component.exports